var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Map',{attrs:{"disabled":"","animate":""}},[_c('MapClusterMarkers',{attrs:{"user-id":_vm.userId}}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }